var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/**
 * Um numero grande com rotulo, icone e mini-serie - o mesmo `MetricCard` que o
 * painel da empresa usa.
 */
let AverageScope = class AverageScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '-';
        /** O icone, pelo nome - ver `lib/lucide-icons.ts` na view. */
        this.icon = '';
        /** A mini-serie ao lado do numero. Vazia quando a metrica nao respondeu. */
        this.spark = [];
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], AverageScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], AverageScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], AverageScope.prototype, "subtitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], AverageScope.prototype, "icon", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], AverageScope.prototype, "spark", void 0);
AverageScope = __decorate([
    Observable
], AverageScope);
export { AverageScope };
/**
 * Um indicador com meta: quanto foi, quanto era o alvo, e quanto do alvo.
 *
 * `kind` diz QUAL dos tres e, e a view usa isso para escolher o icone, as cores e
 * o raio do anel - sao tres aneis concentricos no "Índice de Saúde". Cor e raio sao
 * decisao de renderizacao; o que a apresentacao diz e de que indicador se trata.
 */
let GoalScope = class GoalScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '-';
        this.goal = '-';
        this.percentage = 0;
        this.kind = 'steps';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], GoalScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], GoalScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], GoalScope.prototype, "goal", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], GoalScope.prototype, "percentage", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], GoalScope.prototype, "kind", void 0);
GoalScope = __decorate([
    Observable
], GoalScope);
export { GoalScope };
/**
 * Um ponto da serie. `time` e o instante em milissegundos - o eixo X e numerico,
 * entao os pontos se espacam pelo tempo real entre eles. `high` e `low` so vem
 * preenchidos na PRESSAO, a unica metrica com duas curvas.
 */
let SeriesPointScope = class SeriesPointScope extends Scope {
    constructor() {
        super(...arguments);
        this.time = 0;
        this.value = 0;
        this.count = 0;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SeriesPointScope.prototype, "time", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SeriesPointScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], SeriesPointScope.prototype, "high", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], SeriesPointScope.prototype, "low", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SeriesPointScope.prototype, "count", void 0);
SeriesPointScope = __decorate([
    Observable
], SeriesPointScope);
export { SeriesPointScope };
let MetricOptionScope = class MetricOptionScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.current = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], MetricOptionScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MetricOptionScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MetricOptionScope.prototype, "current", void 0);
MetricOptionScope = __decorate([
    Observable
], MetricOptionScope);
export { MetricOptionScope };
let MetricSelectorScope = class MetricSelectorScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.summary = '';
        this.options = [];
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], MetricSelectorScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MetricSelectorScope.prototype, "summary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], MetricSelectorScope.prototype, "options", void 0);
MetricSelectorScope = __decorate([
    Observable
], MetricSelectorScope);
export { MetricSelectorScope };
/**
 * O painel de um paciente.
 *
 * O mesmo scope serve duas telas: o detalhe do colaborador (dado de um paciente
 * identificado) e o historico compartilhado (dado de um link publico). Quem
 * desenha nao sabe de qual das duas veio.
 */
let PatientAnalyticsScope = class PatientAnalyticsScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.periodDescription = '';
        this.metric = 'FREQUENCIA_CARDIACA';
        this.averages = [];
        this.goals = [];
        this.series = [];
        /**
         * Verdadeiro quando a serie e o HIPNOGRAMA, e nao uma curva de medida.
         *
         * O sono selecionado neste painel desenha os estagios da noite - a view precisa
         * saber para rotular o eixo com Acordado/REM/Leve/Pesado em vez de horas.
         */
        this.sleepStages = false;
        /**
         * O grafico AMPLIADO (B-43): ocupa a area dos cartoes e mostra as referencias. Estado
         * da tela, e nao do endereco.
         */
        this.expanded = false;
        /**
         * As noites como barras do deitar ao acordar, listradas pelas fases (B-41, B-39) - o
         * Sono num periodo de mais de um dia. Num dia so, o hipnograma (`sleepStages`).
         */
        this.nightBars = [];
        /** O resumo acima das barras: tempo dormindo, tempo na cama e a meta da pessoa. */
        this.sleepSummary = [];
        /** As zonas de FC por idade, so nos trechos de treino (B-43). */
        this.references = [];
        this.onToggleExpanded = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientAnalyticsScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], PatientAnalyticsScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientAnalyticsScope.prototype, "periodDescription", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], PatientAnalyticsScope.prototype, "period", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], PatientAnalyticsScope.prototype, "metric", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientAnalyticsScope.prototype, "averages", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientAnalyticsScope.prototype, "goals", void 0);
__decorate([
    observe(),
    __metadata("design:type", MetricSelectorScope)
], PatientAnalyticsScope.prototype, "metricSelector", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientAnalyticsScope.prototype, "series", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientAnalyticsScope.prototype, "sleepStages", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PatientAnalyticsScope.prototype, "expanded", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientAnalyticsScope.prototype, "nightBars", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientAnalyticsScope.prototype, "sleepSummary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], PatientAnalyticsScope.prototype, "references", void 0);
PatientAnalyticsScope = __decorate([
    Observable
], PatientAnalyticsScope);
export { PatientAnalyticsScope };
//# sourceMappingURL=patient-analytics.scope.js.map